import React from 'react';
import { GovFlex } from '@gov-design-system-ce/react';

export interface SectionHeaderProps {
	headline: string;
	id: string;
	children?: React.ReactNode;
	className?: string;
}

export const SectionHeader = ({
	headline,
	id,
	children,
	className,
}: SectionHeaderProps) => (
	<GovFlex
		justifyContent="space-between"
		alignItems="center"
		gap="s"
		responsive="false"
		className={className}>
		<h2 id={id}>{headline}</h2>
		<GovFlex
			gap="s"
			direction="row"
			responsive="false">
			{children}
		</GovFlex>
	</GovFlex>
);
